import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { UserProfileService } from "../event-bus/user-profile.service";

@Injectable()
export class AuditorPermissionsService {
  private auditorStatusSource: BehaviorSubject<boolean>;

  constructor(private userProfileService: UserProfileService) {
    this.auditorStatusSource = new BehaviorSubject<boolean>(
      this.isAuditorProfile(this.getProfileFromStorage())
    );

    this.userProfileService.currentUserProfile.subscribe((profile) => {
      this.auditorStatusSource.next(this.isAuditorProfile(profile));
    });
  }

  get auditorStatus$() {
    return this.auditorStatusSource.asObservable();
  }

  isAuditor(): boolean {
    return this.auditorStatusSource.getValue();
  }

  private getProfileFromStorage(): any {
    var storedProfile = window.localStorage.getItem("userProfile");

    if (!storedProfile) {
      return null;
    }

    try {
      return JSON.parse(storedProfile);
    } catch (error) {
      return null;
    }
  }

  private isAuditorProfile(profile: any): boolean {
    var hasAuditorFlag;
    var role;

    if (!profile) {
      return false;
    }

    hasAuditorFlag =
      profile.is_auditor === 1 ||
      profile.is_auditor === true ||
      profile.is_auditor === "1";
    role = profile.role ? profile.role.toString().toLowerCase() : "";

    return hasAuditorFlag && role === "admin";
  }
}



// WEBPACK FOOTER //
// ./src/app/services/shared/auditor-permissions.service.ts